var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide"},[_c('div',{staticClass:"slide__image",style:({
        backgroundImage: _vm.$helpers.getThumbnail(_vm.slide.image, 2000, {css: true})
      })}),_c('h1',{staticClass:"slide__title"},[_vm._v(_vm._s(_vm.slide.title))]),_c('h2',{staticClass:"slide__subtitle"},[_vm._v(_vm._s(_vm.slide.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }